module.exports = __webpack_public_path__ + "talent-2.jpg?10c5fd7f6f54546ed92f9dc7fc14dcb1";